export default {
  setContacts(state, data) {
    state.list = data;
  },
};
